import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "react-query";
import { Get } from "../utils/api";

export interface Estimate {
  amount: string;
  amount_local: string;
  arrives_by: any;
  attributes: string[];
  carrier_account: string;
  currency: string;
  currency_local: string;
  duration_terms: string;
  estimated_days: number;
  included_insurance_price: any;
  messages: any[];
  object_created: string;
  object_id: string;
  object_owner: string;
  provider: string;
  provider_image_200: string;
  provider_image_75: string;
  servicelevel: Servicelevel;
  shipment: string;
  test: boolean;
  zone: any;
}

export interface Servicelevel {
  display_name: string;
  extended_token: string;
  name: string;
  parent_servicelevel: any;
  terms: string;
  token: string;
}

export default (orderId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery<Estimate[]>(
    `estimate_${orderId}`,
    async () => {
      return await Get<Estimate[]>(
        `/api/shipping/order/${orderId}/estimates`,
        await getAccessTokenSilently()
      );
    },
    {
      enabled: !!orderId,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
};
